// Exports
export default {
	"MainScreen": "MainScreen_KYMMg",
	"Content": "Content_dSyw0",
	"CreateCallButton": "CreateCallButton_OEiow",
	"Loader": "Loader_RHBdn",
	"ButtonContent": "ButtonContent_VH5pR",
	"ButtonsContainer": "ButtonsContainer_8yXwd",
	"ButtonsConnectPlanContainer": "ButtonsConnectPlanContainer_Yx0h0",
	"ConnectCallButton": "ConnectCallButton_Vt8Zv",
	"PlanCallButton": "PlanCallButton_1V8Oe",
	"CreateCallContentLabel": "CreateCallContentLabel_DWfLC",
	"ConnectPlanCallContentLabel": "ConnectPlanCallContentLabel_eASxz",
	"calendarIcon": "calendarIcon_UNdTJ",
	"usersIcon": "usersIcon_2RBOQ",
	"cameraLensIcon": "cameraLensIcon_fmbqM",
	"contentWrapper": "contentWrapper_DgSXX",
	"mainTitle": "mainTitle_Y5D3g",
	"largeMarginBottom": "largeMarginBottom_ZOXxu",
	"middleMarginBottom": "middleMarginBottom_Mmgj-",
	"FourButtonsLayout": "FourButtonsLayout_bhnY1",
	"FourButtonsLayout__Button": "FourButtonsLayout__Button_BNeqC",
	"FourButtonsLayout__Icon": "FourButtonsLayout__Icon_j71kY",
	"FourButtonsLayout__Text": "FourButtonsLayout__Text_QsD0G",
	"FourButtonsLayout__Description": "FourButtonsLayout__Description_7pP0b",
	"FourButtonsLayout__CreateCallButton": "FourButtonsLayout__CreateCallButton_cYyzH",
	"FourButtonsLayout__ConnectCallButton": "FourButtonsLayout__ConnectCallButton_r09r5",
	"conferencesHistoryButton": "conferencesHistoryButton_rzlTo"
};
